// src/fbq.js
export function fbq(...args) {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq(...args);
  } else {
    // queue until fbq is ready
    (window.__fbqQueue = window.__fbqQueue || []).push(args);
  }
}

// flush any queued calls once fbq exists
if (typeof window !== "undefined") {
  const poll = setInterval(() => {
    if (window.fbq && window.__fbqQueue && window.__fbqQueue.length) {
      window.__fbqQueue.forEach(args => window.fbq(...args));
      window.__fbqQueue = [];
      clearInterval(poll);
    }
  }, 100);
}
